<template>
<div>
    <div class="listing-card" :style="{ backgroundImage: `url('${info.PU ? info.PU : (info.AD.substring(0, 4) === '8238' ? missingphoto : blitzlogo)}')` }">
        <div class="listing-content" :style="{ color: `${info.PU || info.AD.substring(0, 4) === '8238' ? '#f8f8f8' : '#020202'}`}">
            <div class="address">
                <h4>{{ info.AD ? info.AD.split(' , ')[0] : 'Gainesville, FL'}}<br>{{info.AD ? info.AD.split(' , ')[1] : '&nbsp;'}}</h4>
                <h6>{{ info.HA ? info.HA : 'Bosshardt Realty'}}, {{ (info.HP ? info.HP.replace(')', ') ') : '(352) 371-6100') }}</h6>
                <h6>{{ 'Sunday ' + info.BT.replace(/PM/g, 'pm').replace('-', ' - ').replace(',', ', ') }}</h6>
            </div>
            
                
            <div>
                <p><span class="price">{{ info.MP ? '$'+ info.MP : '' }}</span>{{ ' ' + info.BR + '&nbsp;bedrooms,&nbsp;' + info.BA + '&nbsp;bathrooms&nbsp;' + (info.SF ? info.SF + '&nbsp;sq.ft.' : '')}}
                </p>
                <b-button v-if="info.SO === 'N'" class="border border-light info-button py-1" target="_blank" v-bind:href="`${'http://gainesville.bosshardtrealty.com/results/?mlsnum='+ info.MN +'&utm_source=BROKERSITE&utm_campaign=Blitz&utm_medium=referral'}`">{{ info.MN ? 'More info' : ''}}</b-button>
                
            </div> 
            
        </div>
        <div class="favorite-icon">
            <font-awesome-icon v-b-tooltip.hover.left="tip" :icon="icon" v-on:click="$emit('favorite', $el)"/>
        </div>
        <div class="location-icon">
            <font-awesome-icon v-b-tooltip.hover.left="'Locate on Map'" :icon="mapIcon" v-on:click="$emit('showOnMap', $el)"/>
        </div>
        <div class="sold-banner" v-if="info.SO === 'Y'">Under Contract</div>
    </div>
    <!-- <div class="listing-card" style="color: black;">
        <div>
            <p>{{ info.F1}}</p>
            <p>{{ info.F2}}</p>
            <p>{{ info.F3}}</p>
            <p>{{ info.F4}}</p>
        </div>
        <div>
            <a target="_blank" v-bind:href="`${'http://gainesville.bosshardtrealty.com/results/?mlsnum='+ info.MN +'&utm_source=BROKERSITE&utm_campaign=Blitz&utm_medium=referral'}`">{{ info.MN ? 'Get the full details here' : ''}}</a>
        </div>
    </div> -->
    
</div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import fontawesome from '@fortawesome/fontawesome'
import faHeartRegular from '@fortawesome/fontawesome-free-regular/faHeart'
import faHeartSolid from '@fortawesome/fontawesome-free-solid/faHeart'
import faMapMarkerAltSolid from '@fortawesome/fontawesome-free-solid/faMapMarkerAlt'
export default {
  name: 'Listing',
  props: ['info', 'favs'],
  data: function () {
    return {
      blitzlogo: require('@/assets/blitzlogo.jpg'),
      missingphoto: require('@/assets/missingphoto.jpg')
    }
  },
  components: {
    FontAwesomeIcon
  },
  computed: {
    icon: function () {
      if (this.favs.includes(this.info.HN)) {
        return faHeartSolid
      } else {
        return faHeartRegular
      }
    },
    mapIcon: function () {
      return faMapMarkerAltSolid
    }
  },
  methods: {
    tip: function () {
      if (this.favs.includes(this.info.HN)) {
        return 'Remove Favorite'
      } else {
        return 'Add Favorite'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .listing-card {
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 5px;
        border: 1px solid #f2f2f2;
        box-shadow: 0 1px 4px rgba(0,0,0,.15);
        position: relative;
    }

    .listing-content {
        padding: .5em;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.20);
        border-radius: 5px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .address {
        max-width: 95%;
    }
    .favorite-icon {
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
        font-size: 1.5rem;
    }
    .location-icon {
        position: absolute;
        right: 5px;
        bottom: 5px;
        cursor: pointer;
        font-size: 1.5rem;
    }
    p {
        font-size: 1.2rem;
        margin-bottom: 0;
    }
    .price {
        font-size: 2rem;
    }

    @media only screen and (max-width: 1500px) {
        p {
            font-size: .8rem;
        }
        h4, .price {
            font-size: 1.2rem;
        }
    

    }
    .info-button, .info-button:hover, .info-button:active, .info-button:focus {
        background-color: #991B31!important;
        outline: none;
        box-shadow: none;
    }

    .sold-banner {
        width: 100%;
        padding: 20px;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        text-align: center;
        background: #991B31;
        font-size: 2em;
        text-transform: uppercase;
        box-shadow: 0px 0px 0px 2px #991B31;
    }


</style>



// WEBPACK FOOTER //
// src/components/Listing.vue